import React, {useEffect, useState, Fragment} from 'react';
import './App.css';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import FadeIn from 'react-fade-in';
import  { Rates  } from "rate-quotes";
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  const [show, setShow] = useState(false);
  const [showRates, setShowRates] = useState(false);
  const [ckCode, setCkCode] = useState("");
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if(ckCode === "ck") {
      setShow(false);
      setShowRates(true);
      setValidated(true);
    }
  };

  useEffect(() => {
    if(ckCode === "ck") {
      setShow(false);
      setShowRates(true);
    } else {
      setShow(true);
      setShowRates(false);
    }
  }, []);


  return (
    <Fragment>
      { ckCode === "ck" && showRates ? <FadeIn><Header /></FadeIn> : null }
        <Modal show={show} centered backdrop="static">
          <Modal.Body className="px-2">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <h6 className="text-center textBlue">Welcome Credit Karma customer, enter your code to uncover rates tailored just for you.</h6>
              <Form.Label htmlFor="code" srOnly>Promo code</Form.Label>
              <Form.Control
                type="text"
                id="code"
                required
                onChange={e => {setCkCode(e.target.value.toLowerCase())}}
              />
              <div className="text-center">
                <Button type="submit" className="mt-3">Submit</Button>
              </div>
            </Form>
          </Modal.Body>
      </Modal>
      { ckCode === "ck" && showRates? <FadeIn> 
        <Rates leadSource="CREDKARMA" />
      </FadeIn> : null }
      { ckCode === "ck" && showRates ? <FadeIn>  <Footer /> </FadeIn> : null }
    </Fragment>
  );
}

export default App;
